function requestJSON(method, url, params, success)
{
	let xhr = new XMLHttpRequest();

	xhr.open(method, url);
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.responseType = 'json';

	xhr.onload = function () {
		if (this.status === 200) { // analyze HTTP status of the response
			success(this);
		} else {
			alert(`Error ${this.status}: ${this.statusText}`); // e.g. 404: Not Found
		}
	};

	xhr.onerror = function () {
		alert("Request failed");
	};

	xhr.send(params ? JSON.stringify(params) : null);

	return xhr;
}

export {requestJSON};
